












































































































































import {
  Component,
  Prop,
  Vue,
  Watch
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import {
  Address,
  HsabExpenseCategory,
  HsabExpenseRequest,
  HsabExpenseResponse
} from "@/shared/types";
import _ from "lodash";
import moment from "moment/moment";
import { formatCurrency } from "@/shared/currency.js";
import { useContactInfoStore } from "@/shared/store/contactinfo";

@Component({
  components: {
    GenericLoadingSpinner
  }
})
export default class HsabExpenseSubmitConfirmation extends Vue {
  contactInformationStore = useContactInfoStore();
  formatCurrency = formatCurrency;
  agreedToTerms = false;

  @Prop({ required: true })
  expense: HsabExpenseResponse;

  @Prop({ required: true })
  expenseForm: HsabExpenseRequest;

  @Prop({ required: true })
  expenseSaving: boolean;

  @Prop({ required: true })
  recipientDisplay: string;

  @Watch("expenseForm.isPayToPayee")
  updateContactInfo () {
    if (!this.expenseForm.isPayToPayee) {
      this.contactInformationStore.getContactInformation();
    }
  }

  mounted () {
    this.agreedToTerms = false;
  }

  get showCategoryInReview () {
    return this.expenseForm.expenseCategory !== undefined
        && this.expenseForm.expenseCategory !== null
        && this.expenseForm.expenseCategory !== HsabExpenseCategory.Unknown;
  }

  get showExpenseTypeInReview () {
    return this.expenseForm.expenseType !== undefined
        && this.expenseForm.expenseType !== null
        && this.expenseForm.expenseType !== "";
  }

  get showExpenseSubTypeInReview () {
    return this.expenseForm.expenseSubType !== undefined
        && this.expenseForm.expenseSubType !== null
        && this.expenseForm.expenseSubType !== "";
  }

  get allFilesForReview () {
    let results = _.map(this.expenseForm.stagedFilesForUpload, x => x.name);

    if (this.expense && this.expense.expenseEvidence) {
      const existingEvidence = this.expense.expenseEvidence;
      const existingFileNames = _.map(existingEvidence, e => e.fileName);
      results = results.concat(existingFileNames);
    }

    return results;
  }

  get formattedServiceDate () {
    return moment(this.expenseForm.dateOfService).format("MMMM DD, YYYY");
  }

  get sendPaymentTo () {
    if (this.expenseForm.isPayToPayee) {
      return this.expenseForm.payeeName;
    } else {
      return this.subscriberDisplay;
    }
  }

  get subscriberDisplay () {
    return this.contactInformationStore.contactInformation.firstName + " " + this.contactInformationStore.contactInformation.lastName;
  }

  get mailingAddress (): Address {
    if (!this.contactInformationStore
        || !this.contactInformationStore.contactInformation
        || !this.contactInformationStore.contactInformation.mailingAddress) {
      return null;
    }

    return this.contactInformationStore.contactInformation.mailingAddress;
  }

  truncateFileName (filename) {
    const maxLength = 30;
    const postfixCharacterCount = 7;
    if (filename.length > maxLength) {
      return filename.slice(0, maxLength - (postfixCharacterCount + 3)) + "..." +
          filename.slice(filename.length - postfixCharacterCount, filename.length);
    }
    return filename;
  }

  onConfirmSubmitClicked () {
    this.$emit("confirmSubmit");
  }

  onBackClicked () {
    this.$emit("back");
  }

  isStringNullOrEmpty (str) {
    return str === undefined || str === null || str === "";
  }
}
